// extracted by css-extract-rspack-plugin
export default {"Button_0":"BooleanValueSelect-module__Button_0__DRjmU","Octicon_0":"BooleanValueSelect-module__Octicon_0__AAfC3"};